module.exports = __webpack_public_path__ + "static/media/info-warning.25f26cc5.svg";